import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface ImageTextlineProps {
  textline: string;
  shouldShowLineOnlyOnHover?: boolean;
  shouldWrap?: boolean;
  upperCase?: boolean;
  removeBottomMargin?: boolean;
  dataTestId: string;
}
export const ImageTextline: React.FC<ImageTextlineProps> = ({
  textline,
  shouldShowLineOnlyOnHover = false,
  shouldWrap = true,
  upperCase = false,
  removeBottomMargin,
  dataTestId,
}) => {
  if (shouldShowLineOnlyOnHover) {
    return (
      <OnHoverAppearingTextline
        data-testid={dataTestId}
        shouldWrap={shouldWrap}
        upperCase={upperCase}
        removeBottomMargin={removeBottomMargin}
      >
        {textline}
      </OnHoverAppearingTextline>
    );
  }

  return (
    <StyledTextline
      data-testid={dataTestId}
      shouldWrap={shouldWrap}
      upperCase={upperCase}
      removeBottomMargin={removeBottomMargin}
    >
      {textline}
    </StyledTextline>
  );
};

const StyledTextline = styled.p<{
  shouldWrap: boolean;
  upperCase: boolean;
  removeBottomMargin?: boolean;
}>`
  z-index: ${Z_INDEXES.TADARIDA_HEADER_IMG_TEASER_TEXTLINE};
  color: ${COLORS.White};
  display: block;
  font-size: ${FONT_SIZES.px12};
  line-height: ${FONT_SIZES.px12};
  word-break: break-word;
  text-align: center;
  max-width: 90%;
  font-weight: ${FONT_WEIGHTS.bold};
  margin-bottom: ${({removeBottomMargin}) =>
    removeBottomMargin ? '0' : '4px'};
  text-transform: ${({upperCase}) => (upperCase ? 'uppercase' : 'inherit')};

  white-space: ${props => (props.shouldWrap ? 'normal' : 'nowrap')};
`;

export const OnHoverAppearingTextline = styled(StyledTextline)`
  transition: opacity 0.3s ease;
`;
